<template>
  <div class="container-fluid">
    <div  class="card border-primary shadow-lg">
      <div class="card-header text-white bg-primary mb-3">
        <label>{{ $t('menu.billing.debtors.title') }}</label>
      </div>
      <div class="card-body">
        <TableField
            v-model:params="params"
            :data="debtors"
            :columns="columns"
            :loading="loading"
            showSearch
            stickyHeader
            columnChooser
            mobileDevices
            storeSearch
            section="debtors"
            @fetch-data="populateData"
            @action="handleAction"
        >
          <template #filters>
            <div class="row g-2 align-items-end">
              <div class="col-12 col-md-6 col-xl-6 col-xxl-6">
                <div class="row align-items-center">
                  <label class="col-12 col-md-4 col-form-label text-md-end">
                    {{ $t('debtors.status') }}
                  </label>

                  <div class="col-12 col-md-8 my-1">
                    <AdvancedSelect
                        v-model="params.filter.isBlockedClient"
                        :hideClearIcon="true"
                        :items="[
                          { text: $t('debtors.option.all'), value: '' },
                          { text: $t('debtors.option.active'), value: 0 },
                          { text: $t('debtors.option.blocked'), value: 1 }
                        ]"
                        @change="populateData()"
                    />
                  </div>
                </div>
              </div>

              <div class="col-12 col-md-6 col-xl-6 col-xxl-6">
                <div class="row align-items-center">
                  <label class="col-12 col-md-4 col-form-label text-md-end">
                    {{ $t('debtors.name') }}
                  </label>

                  <div class="col-12 col-md-8 my-1">
                    <AdvancedSelect
                        v-model="params.filter.isClientEnabled"
                        :hideClearIcon="true"
                        :items="[
                          { text: $t('debtors.option.all'), value: '' },
                          { text: $t('debtors.option.active'), value: 1 },
                          { text: $t('debtors.option.inactive'), value: 0 }
                        ]"
                        @change="populateData()"
                    />
                  </div>
                </div>
              </div>
            </div>
          </template>
        </TableField>
      </div>
    </div>

    <AddComment ref="addModalComment" />
    <ShowHistoryAccounts ref="showHistoryAccounts" />
    <ModalMessageDebtor ref="sendBlockMsgBox" @confirm="sendMessage($event, 1)"/>
  </div>
</template>

<script src="./Debtors.js"></script>
